import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import SharedGallery from './pages/SharedGallery';
import Admin from './pages/Admin';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/s/:token" element={<SharedGallery />} />
        <Route path="/dtmedia" element={<Navigate to="/dtmedia/admin" replace />} />
        <Route path="/dtmedia/admin" element={<Admin />} />
        <Route path="/dtmedia/s/:token" element={<SharedGallery />} />
        <Route path="/admin" element={<Navigate to="/dtmedia/admin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
